import type { Observable } from 'rxjs/Observable';
import fetchJson$ from '@atlassian/jira-fetch/src/utils/as-json-stream.tsx';

const deleteBoard = (boardId: string): Observable<void> => {
	const url = `/rest/agile/1.0/board/${boardId}`;
	const options = {
		method: 'delete',
	};
	return fetchJson$(url, options);
};

export default deleteBoard;
